module.exports = __webpack_public_path__ + "static/media/19.704e0f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/19.png
// module id = 1260
// module chunks = 0